import templateUrl from './animal-history.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    symptoms: '<',
    locked: '<'
  },
  controller: class AnimalHistoryComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    get showConclusionQuestion() {
      return this.adverseEvent.Question9a === true;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-history/animal-history.component.js